import keys from "./keys";
import validation from "./validation";

export default {
    validationErrors: validation,
    ...keys,
    'Optional': 'Optioneel',
    'No options found': 'Geen verdere opties meer beschikbaar',
};
